export function parseWwwAuthenticate(str: string): {
    authority: string;
    clientId: string;
    scopes: string[];
    proposedAction: string;
} {
    const parts = str?.split(' ')?.splice(1);
    if (parts == null) {
        return null;
    }

    const consentUri = /consentUri="(?<consentUri>.+?)"/i;
    const authority = /(?<authority>.+?)\/+?oauth2/i;
    const clientId = /client_id=(?<clientId>.+?)(?:&|$)/i;
    const scopes = /scope=(?<scopes>.+?)(?:&|$)/i;
    const proposedAction = /proposedAction="(?<proposedAction>.+?)"/i;

    const result = {
        authority: null,
        clientId: null,
        scopes: null,
        proposedAction: null,
    };

    parts.forEach((e) => {
        let m: RegExpMatchArray;

        m = e.match(consentUri);
        if (m?.groups != null) {
            const uri = m.groups.consentUri;

            m = uri?.match(authority);
            if (m?.groups != null) {
                result.authority = `${m.groups.authority}/`;
            }

            m = uri?.match(clientId);
            if (m?.groups != null) {
                result.clientId = m.groups.clientId;
            }

            m = uri?.match(scopes);
            if (m?.groups != null) {
                result.scopes = m.groups.scopes?.split('%20');
            }
        }

        m = e.match(proposedAction);
        if (m?.groups != null) {
            result.proposedAction = m.groups.proposedAction;
        }
    });

    return result;
}
